import { ALL_MISTAKE_TYPES } from "@app/routes/activities/reading/constants";
import { RECORDING_STATUS } from "@app/routes/treatmentV3/constants";
import { selectAnaliticsTrackEventFunc, selectWordState, selectRecordingStatus } from "@app/routes/activities/reading/store/readingSlice";

const getReadingDefaultProperties = () => ({});

export const trackReadingEvent = (eventName, state, boardId, additionalParams = {}) => {
  // selectAnaliticsTrackEventFunc(boardId)?.(state)?.(eventName, { ...additionalParams, ...getReadingDefaultProperties(state) });
  selectAnaliticsTrackEventFunc(state, boardId)?.(eventName, { ...additionalParams, ...getReadingDefaultProperties(state) });
};

export const trackWordProblemEvent = (state, stateBefore, boardId, action) => {
  const problemType = action?.payload?.value?.problemType;
  const wordId = action?.payload?.value?.wordId;

  const wordStateBefore = selectWordState(stateBefore, boardId)?.(boardId, undefined, wordId);
  const recordingStatus = selectRecordingStatus(state, boardId);

  const params = {
    is_running_timer: recordingStatus === RECORDING_STATUS.RECORDING,
    is_update: undefined,
  };

  if (!problemType) {
    trackReadingEvent(
      ALL_MISTAKE_TYPES.includes(wordStateBefore?.problemType) ? "reading_unmark_mistake" : "reading_unmark_difficultie",
      state, boardId, params,
    );
    return;
  }

  params.is_update = !!(wordStateBefore?.problemType);

  if (ALL_MISTAKE_TYPES.includes(problemType)) {
    trackReadingEvent("reading_mark_mistake", state, boardId, { ...params, mistake_id: problemType });
  } else {
    trackReadingEvent("reading_mark_difficultie", state, boardId, { ...params, difficultie_id: problemType });
  }
};

export const trackcSharedPointerEvent = (state, stateBefore, boardId, action) => {
  const isShared = action?.payload?.value;
  trackReadingEvent(isShared ? "reading_enable_shared_pointer" : "reading_disable_shared_pointer", state, boardId);
};

export const trackcRecordingStatusEvent = (state, stateBefore, boardId, action) => {
  const recordingStatus = action?.payload?.value;
  recordingStatus === RECORDING_STATUS.RECORDING && trackReadingEvent("reading_timer_start", state, boardId);
};

export const trackcDoneEvent = (state, stateBefore, boardId, action) => {
  const isDone = action?.payload?.isDone;
  isDone && trackReadingEvent("reading_done", state, boardId);
};
